export const SETTINGS_SECTION_TITLE = 'SETTINGS_SECTION_TITLE';
export const SETTINGS_APP_LANGUAGE = 'SETTINGS_APP_LANGUAGE';
export const SETTINGS_ABOUT_APP = 'SETTINGS_ABOUT_APP';
export const SETTINGS_PARENTAL_CONTROL_AND_PIN =
    'SETTINGS_PARENTAL_CONTROL_AND_PIN';
export const SETTINGS_LANGUAGE_AUDIO_SUBTITLES =
    'SETTINGS_LANGUAGE_AUDIO_SUBTITLES';
export const SETTINGS_DELETE_HISTORY = 'SETTINGS_DELETE_HISTORY';
export const SETTINGS_HELP = 'SETTINGS_HELP';
export const APP_SETTINGS_LOGOUT_OPTION = 'APP_SETTINGS_LOGOUT_OPTION';
export const SETTINGS_SYSTEM_INFORMATION = 'SETTINGS_SYSTEM_INFORMATION';
export const SYSTEM_INFORMATION_HARDWARE_BRAND_NAME =
    'SYSTEM_INFORMATION_HARDWARE_BRAND_NAME';
export const SYSTEM_INFORMATION_MODEL_NAME = 'SYSTEM_INFORMATION_MODEL_NAME';
export const SYSTEM_INFORMATION_HARDWARE_VERSION =
    'SYSTEM_INFORMATION_HARDWARE_VERSION';
export const SYSTEM_INFORMATION_HARDWARE_SERIAL_NUMBER =
    'SYSTEM_INFORMATION_HARDWARE_SERIAL_NUMBER';
export const SYSTEM_INFORMATION_SOFTWARE_VERSION =
    'SYSTEM_INFORMATION_SOFTWARE_VERSION';
export const SYSTEM_INFORMATION_EPG_DATA = 'SYSTEM_INFORMATION_EPG_DATA';
export const SYSTEM_INFORMATION_ACCOUNT_ID = 'SYSTEM_INFORMATION_ACCOUNT_ID';
export const SYSTEM_INFORMATION_UI_VERSION = 'SYSTEM_INFORMATION_UI_VERSION';
export const SYSTEM_INFORMATION_ENVIRONMENT = 'SYSTEM_INFORMATION_ENVIRONMENT';
export const SYSTEM_INFORMATION_UUID = 'SYSTEM_INFORMATION_UUID';
export const SCREEN_SETTINGS_ABOUT_INFO_NOT_AVAILABLE =
    'SCREEN_SETTINGS_ABOUT_INFO_N/A';
export const SETTING_HELP_EXTERNAL_LINK = 'SETTING_HELP_EXTERNAL_LINK';

export const SETTINGS_RECORDING_QUOTA = 'SETTINGS_RECORDING_QUOTA';
export const SETTINGS_STREAMING_SUBSCRIPTIONS =
    'SETTINGS_STREAMING_SUBSCRIPTIONS';
export const SETTINGS_CHANNEL_LINEUP_SWITCH_CHANNEL_LIST =
    'SETTINGS_CHANNEL_LINEUP_SWITCH_CHANNEL_LIST';
export const SETTINGS_CONSENTS = 'SETTINGS_CONSENTS';
export const SETTINGS_SPOTLIGHT_VIDEO = 'SETTINGS_SPOTLIGHT_VIDEO';

export const SETTINGS_DISPLAY = 'SETTINGS_DISPLAY';
export const SETTINGS_DISPLAY_EPG_OPTIONS = 'SETTINGS_DISPLAY_EPG_OPTIONS';
export const SETTINGS_DISPLAY_EPG_OPTIONS_CLASSIC =
    'SETTINGS_DISPLAY_EPG_OPTIONS_CLASSIC';
export const SETTINGS_DISPLAY_EPG_OPTIONS_NEW =
    'SETTINGS_DISPLAY_EPG_OPTIONS_NEW';

export const SCREEN_HELP_TITLE = 'SCREEN_HELP_TITLE';
export const SCREEN_HELP_BODY = 'SCREEN_HELP_BODY';
export const SCREEN_HELP_BODY_MOBILE = 'SCREEN_HELP_BODY_MOBILE';
export const SCREEN_HELP_WEBSITE_BUTTON = 'SCREEN_HELP_WEBSITE_BUTTON';
export const SCREEN_HELP_CLOSE_BUTTON = 'SCREEN_HELP_CLOSE_BUTTON';

export const SCREEN_PARENTAL_CONTORL_TITLE =
    'SETTINGS_PARENTAL_CONTROL_AND_PIN';

export const SETTINGS_PARENTAL_CONTROL = 'SETTINGS_PARENTAL_CONTROL';

export const SETTINGS_AUDIO_LANGUAGE = 'SETTINGS_AUDIO_LANGUAGE';
export const SETTINGS_SUBTITLE_LANGUAGE = 'SETTINGS_SUBTITLE_LANGUAGE';
export const SCREEN_SUBTITLE_OFF = 'SCREEN_SUBTITLE_OFF';

export const SETTINGS_STREAMING_SUBSCRIPTIONS_OVERLAY_TITLE =
    'SETTINGS_STREAMING_SUBSCRIPTIONS_OVERLAY_TITLE';
export const SETTINGS_STREAMING_SUBSCRIPTIONS_OVERLAY_DESCRIPTION_RN =
    'SETTINGS_STREAMING_SUBSCRIPTIONS_OVERLAY_DESCRIPTION_RN';

export const SCREEN_SETTINGS_ALERT_AUDIO_SUBTITLES_TITLE =
    'SCREEN_SETTINGS_ALERT_AUDIO_SUBTITLES_TITLE';
export const SCREEN_SETTINGS_ALERT_AUDIO_SUBTITLES_BODY =
    'SCREEN_SETTINGS_ALERT_AUDIO_SUBTITLES_BODY';
export const SCREEN_SETTINGS_ALERT_AUDIO_SUBTITLES_OK_BUTTON =
    'SCREEN_SETTINGS_ALERT_AUDIO_SUBTITLES_OK_BUTTON';

export const SETTINGS_CHANNEL_LINEUP = 'SETTINGS_CHANNEL_LINEUP';
export const SETTINGS_CHANNEL_LINEUP_STANDARD_LIST =
    'SETTINGS_CHANNEL_LINEUP_STANDARD_LIST';
export const SETTINGS_CHANNEL_LINEUP_MY_LIST =
    'SETTINGS_CHANNEL_LINEUP_MY_LIST';
export const STANDARD_BUTTON = 'STANDARD_BUTTON';
export const SETTINGS_CHANNEL_LINEUP_CREATE_MY_LIST_RN =
    'SETTINGS_CHANNEL_LINEUP_CREATE_MY_LIST_RN';
export const SETTINGS_CHANNELS_MY_LIST_DESCRIPTION_RN =
    'SETTINGS_CHANNELS_MY_LIST_DESCRIPTION_RN';
export const RESET_BUTTON = 'RESET_BUTTON';
export const START_BUTTON = 'START_BUTTON';
export const BACK_BUTTON = 'BACK_BUTTON';
export const FTI_CHANNELS_MY_LIST_TITLE = 'FTI_CHANNELS_MY_LIST_TITLE';
export const MY_LIST_ALL_CHANNELS_HIDDEN_TITLE =
    'MY_LIST_ALL_CHANNELS_HIDDEN_TITLE';
export const MY_LIST_ALL_CHANNELS_HIDDEN_BODY =
    'MY_LIST_ALL_CHANNELS_HIDDEN_BODY';
export const SCREEN_AUDIO_SUBTITLES_TITLE_GOT_IT_BUTTON =
    'SCREEN_AUDIO_SUBTITLES_TITLE_GOT_IT_BUTTON';
export const FTI_CHANNELS_MY_LIST_SAVE_TITLE =
    'FTI_CHANNELS_MY_LIST_SAVE CHANGES_TITLE';
export const FTI_CHANNELS_MY_LIST_SAVE_DESCRIPTION =
    'FTI_CHANNELS_MY_LIST_SAVE CHANGES_DESCRIPTION';
export const SETTINGS_CHANNEL_SCAN_CUSTOMIZE_MY_LIST_BUTTON =
    'SETTINGS_CHANNEL_SCAN_CUSTOMIZE_MY_LIST_BUTTON';
export const SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST =
    'SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST';
export const SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST_TITLE =
    'SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST_TITLE';
export const SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST_DESCRIPTION =
    'SETTINGS_CHANNEL_LINEUP_CLEAR_MY_LIST_DESCRIPTION';
export const SETTINGS_CHANNEL_SCAN_CHOOSE_BETWEEN_LISTS_BUTTON =
    'SETTINGS_CHANNEL_SCAN_CHOOSE_BETWEEN_LISTS_BUTTON';
export const BUTTON_SAVE_CHANGES = 'BUTTON_SAVE_CHANGES';
export const BUTTON_CANCEL_CHANGES = 'BUTTON_CANCEL_CHANGES';

export const SETTINGS_RECORDING_QUOTA_TITLE = 'SETTINGS_RECORDING_QUOTA_TITLE';
export const SETTINGS_RECORDING_QUOTA_BODY_REACT_NATIVE =
    'SETTINGS_RECORDING_QUOTA_BODY_REACT_NATIVE';
export const SETTINGS_RECORDING_QUOTA_NOT_ENTITLED_TITLE =
    'SETTINGS_RECORDING_QUOTA_NOT_ENTITLED_TITLE';
export const SETTINGS_RECORDING_QUOTA_NOT_ENTITLED_BODY_REACT_NATIVE =
    'SETTINGS_RECORDING_QUOTA_NOT_ENTITLED_BODY_REACT_NATIVE';
export const SCREEN_SETTINGS_RECORDING_QUOTA_HOURS_USED =
    'SCREEN_SETTINGS_RECORDING_QUOTA_HOURS_USED';
export const SCREEN_SETTINGS_RECORDING_QUOTA_HOURS_PROTECTED =
    'SCREEN_SETTINGS_RECORDING_QUOTA_HOURS_PROTECTED';
export const SELFCARE_APP_BUTTON = 'SELFCARE_APP_BUTTON';
export const SCREEN_DETAIL_TIME_HOURS = 'SCREEN_DETAIL_TIME_HOURS';

export const SETTINGS_PARENTAL_CONTROL_6 = 'SETTINGS_PARENTAL_CONTROL_6';
export const SETTINGS_PARENTAL_CONTROL_12 = 'SETTINGS_PARENTAL_CONTROL_12';
export const SETTINGS_PARENTAL_CONTROL_16 = 'SETTINGS_PARENTAL_CONTROL_16';
export const SETTINGS_PARENTAL_CONTROL_18 = 'SETTINGS_PARENTAL_CONTROL_18';
export const SETTINGS_PARENTAL_CONTROL_ADULTS_CENSORED =
    'SETTINGS_PARENTAL_CONTROL_ADULTS_CENSORED';
export const SETTINGS_PARENTAL_CONTROL_ADULTS_UNCENSORED =
    'SETTINGS_PARENTAL_CONTROL_ADULTS_UNCENSORED';

export const SETTINGS_BACKEND_INFORMATION = 'SETTINGS_BACKEND_INFORMATION';
export const BACKEND_INFORMATION_LAST_PROVISION_DATE =
    'BACKEND_INFORMATION_LAST_PROVISION_DATE';
export const BACKEND_INFORMATION_LAST_CONNECTION_TO_OTT =
    'BACKEND_INFORMATION_LAST_CONNECTION_TO_OTT';
export const SETTINGS_RN_INTERNET_CONNECTION_OPTIONS =
    'SETTINGS_RN_INTERNET_CONNECTION_OPTIONS';
export const SETTINGS_RN_INTERNET_CONNECTION_WIFI_ONLY =
    'SETTINGS_RN_INTERNET_CONNECTION_WIFI_ONLY';
export const SETTINGS_RN_INTERNET_CONNECTION_WIFI_AND_MOBILE_DATA =
    'SETTINGS_RN_INTERNET_CONNECTION_WIFI_AND_MOBILE_DATA';

export const SETTINGS_AUDIO_SUBTITLE_FONT_SIZE =
    'SETTINGS_AUDIO_SUBTITLE_FONT_SIZE';

export const SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_SMALL =
    'SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_SMALL';
export const SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_MEDIUM =
    'SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_MEDIUM';
export const SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_LARGE =
    'SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_LARGE';
export const SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_EXTRA_LARGE =
    'SETTINGS_AUDIO_SUBTITLE_FONT_SIZE_EXTRA_LARGE';
export const SETTINGS_DELETE_HISTORY_NOTIFICATION_TITLE =
    'SETTINGS_DELETE_HISTORY_NOTIFICATION_TITLE';
export const SETTINGS_DELETE_HISTORY_NOTIFICATION_DESCRIPTION =
    'SETTINGS_DELETE_HISTORY_NOTIFICATION_DESCRIPTION';
export const DELETE_BUTTON = 'DELETE_BUTTON';
export const CLOSE_BUTTON = 'CLOSE_BUTTON';
